<style scoped>
.title {
  /* text-align: right; */
  font-size: 14px;
  padding-bottom: 15px;
  padding-top: 5px;
}
.title span {
  margin: 0 8px;
  font-size: 14px;
}
.title span.isActive {
  color: #34a1ef;
}
</style>

<template>
  <div class="title">
    <span
      v-for="(item,index) in title"
      :key="index"
      :class="{'isActive':item.value==defaultTab}"
      @click="changeTab(item.value)"
    >{{item.name}}</span>
  </div>
</template>
<script>
/**
 * @file:  View 组件 tab切换
 * @author: v_chengmengya
 * @date: 2019-05-17
 * @description: UI组件
 */
export default {
  props: {
    title: {
      default: () => {
        return []
      },
      type: Array
    },
    defaultTab: {
      default: '',
      type: String
    },
    changeTab: {
      default: () => {},
      type: Function
    }
  }
}
</script>

